const Ideas = [
    "Aprender a dançar salsa.",
    "Fazer uma festa mexicana.",
    "Saber mais sobre o planeta Marte.",
    "Fazer biscoitos de limão.",
    "Cantar os hits do ano 2000.",
    "Ouvir um disco de Tom Jobim.",
    "Ver um filme sobre o fim do mundo.",
    "Ler um livro em família - cada um lê um parágrafo.",
    "Sessão de massagem em cadeia.",
    "Tirar do armário para doar, tudo o que não foi usado no último ano.",
    "Replicar uma cena da série favorita.",
    "Fazer um karaoke.",
    "Experimentar mudar a disposição da sala.",
    "Às 22h, ir à janela com lençóis à volta, tipo fantasma.",
    "Ir à janela gritar em coro 'VAI FICAR TUDO BEM'.",
    "Fazer um teatro.",
    "Pensar como vai ser o almoço de Páscoa.",
    "Fazer sessão de fotografias tipo influencer.",
    "20 minutos de meditação em família. Quem quebrar lava a loiça 2 dias.",
    "Fazer campeonato de jogo do sério.",
    "Jogar jogo de tabuleiro.",
    "Jogar ao STOP.",
    "Dizerem uns aos outros o que mais gostam em cada um.",
    "Inventar uma receita completamente nova.",
    "Usarem as roupas uns dos outros.",
    "Aprender uma nova língua.",
    "Começar um curso de HTML.",
    "Ver um vídeo sobre marcenaria.",
    "Fazer um treino em família.",
    "Fazer um puzzle.",
    "Voltar a instalar o Farmville.",
    "Rever a final do Euro 2016.",
    "Decorar uma música de Eros Ramazotti.",
    "Ver um filme do Tentin Quarentino.",
    "Ler A Peste, de Albert Camus.",
    "Escrever uma história .",
    "Fazer uma visita virtual a um museu.",
    "Ver o Rei Leão.",
    "Fazer maratona de Guerra das Estrelas.",
    "Fazer maratona de Harry Potter.",
    "Fazer maratona de Senhor dos Anéis.",
    "Fazer maratona de Game of Thrones.",
    "Criar uma coreografia em família.",
    "Donos de Animais: fazer vídeo com eles.",
    "Arrumar aquela arrecadação 'proibida'.",
    "Fazer um desenho.",
    "Fazer caricaturas dos membros da família.",
    "Organizar a prateleira dos temperos.",
    "Organizar a gaveta das meias.",
    "Arranjar aquela porta que está perra há meses.",
    "Aprender técnicas de sobrevivência no mato.",
    "Fazer maratona de The Walking Dead.",
    "(Tentar) observar constelações.",
    "Fazer uma banda com instrumentos feitos em casa (baldes, panelas, copos, you name it).",
    "Planear o verão 2021.",
    "Aproveitar para lavar todos os sapatos.",
    "Ensinar novos truques aos pets.",
    "Pintar o cabelo de outra cor.",
    "Fazer yoga em família.",
    "Fazer uma Kombucha em casa.",
    "Fazer pão em família.",
    "Organizar a papelada da família.",
    "Ir registando as faturas deste ano.",
    "Fazer penteados de famosos e adivinhar quem são.",
    "Fazer a noite do terror, com filmes e histórias.",
    "Aprender a fazer o pino.",
    "Fazer air guitar da música We Will Rock You, dos Queen, com a vassoura.",
    "Aprender mais sobre agricultura.",
    "Aprender mais sobre os animais.",
    "Aprender a fazer um nó de gravata.",
    "Partilhar um segredo vergonhoso.",
    "Organizar um quizz. Quem ganhar não lava a loiça durante uma semana.",
    "Fazer uma apreciação da vida e obra de António Calvário.",
    "Tirar uma selfie com 2m de distanciamento entre cada membro da família.",
    "Acordar para ver o nascer do sol ou a sua luz.",
    "Fazer uma refeição completamente vegan.",
    "Imitar uma ceia de Natal, com presentes feitos à mão.",
    "Perguntar ao/à vizinho/a mais velho/a se precisa de alguma coisa do supermercado.",
    "Escrever uma carta.",
    "Fazer curso de datilografia para escrever sem olhar para o teclado",
    "Aprender o alfabeto fonético da NATO (Alfa, Bravo, Charlie, ...)",
    "Aprender um truque de magia com cartas.",
    "Conhecer a obra de Pablo Picasso.",
    "Aprender o significado de cada um dos nomes da família.",
    "Jogar ao ‘O chão é lava’.",
    "Abraçar toda a gente lá em casa uma vez por dia, mesmo que estejam chateados.",
    "Aprender uma nova língua.",
    "Pesquisar sobre os mais parvos recordes do mundo.",
    "Aprender tai-chi.",
    "Planear uma escapadinha em Portugal, para quando isto acabar.",
    "Fazer um jantar com amigos via hangouts.",
    "Aprender mais sobre inteligência emocional.",
    "Tentar perceber o porquê da panca do papel higiénico.",
    "Ligar aos familiares mais afastados.",
    "Inventar uma ideia que possa ajudar alguém no Mundo.",
    "Cultivar um abacateiro num copo com água.",
    "Desenhar um mapa e apresentar a meteorologia num live do Instagram.",
    "Treinar escrever com a mão não dominante."
]

export default Ideas;